<main class="it-editor" *ngIf="vm.activeRequest; else noActiveRequest">
	<div class="it-requestbar">
		<dx-select-box class="it-method-dd" [items]="vm.allowedMethods" [value]="vm.activeRequest.method" (onValueChanged)="updateRequest.emit({ method: $event.value })">
		</dx-select-box>

		<input class="it-url" type="text" [value]="vm.activeRequest.url" (input)="updateRequest.emit({ url: $any($event.target).value })" placeholder="https://... or /relative/path" />

		<button class="it-send" type="button" [disabled]="vm.isSending || !vm.selectedIntegrationId || !vm.selectedLoginId" (click)="send.emit()">
      {{ vm.isSending ? 'Sending...' : 'Send' }}
    </button>
	</div>

	<div class="it-tabstrip">
		<button type="button" class="it-tab" [class.is-active]="vm.subTab==='body'" (click)="setSubTab.emit('body')">Body</button>
		<button type="button" class="it-tab" [class.is-active]="vm.subTab==='params'" (click)="setSubTab.emit('params')">Query</button>
		<button type="button" class="it-tab" [class.is-active]="vm.subTab==='headers'" (click)="setSubTab.emit('headers')">Headers</button>
		<button type="button" class="it-tab" disabled>Docs</button>

		<div class="it-tabstrip-spacer"></div>

		<div class="it-namefield">
			<input class="it-name" type="text" [value]="vm.activeRequest.name" (input)="updateRequest.emit({ name: $any($event.target).value })" placeholder="Request name" />
		</div>
	</div>

	<div class="it-editpane">
		<it-body-tab *ngIf="vm.subTab==='body'" [request]="vm.activeRequest" (updateRequest)="updateRequest.emit($event)" (formatBody)="formatBody.emit()" (clearBody)="clearBody.emit()">
		</it-body-tab>

		<it-params-tab *ngIf="vm.subTab==='params'" [request]="vm.activeRequest" (add)="addParam.emit()" (updateKv)="updateParam.emit($event)" (remove)="removeParam.emit($event)" (clear)="clearParams.emit()">
		</it-params-tab>

		<it-headers-tab *ngIf="vm.subTab==='headers'" [request]="vm.activeRequest" (add)="addHeader.emit()" (addCommon)="addCommonHeaders.emit()" (updateKv)="updateHeader.emit($event)" (remove)="removeHeader.emit($event)" (clear)="clearHeaders.emit()">
		</it-headers-tab>
	</div>
</main>

<ng-template #noActiveRequest>
	<main class="it-editor it-editor-empty">
		<div class="it-empty-big">Select a request on the left, or create one in a collection.</div>
	</main>
</ng-template>
